<template>
  <g>
    <path
      d="M27.6255 14.3659L16.5511 6.18409C16.2189 5.93864 15.7759 5.93864 15.4437 6.18409L4.36922 14.3659C4.05544 14.6023 3.91701 15.0114 4.04621 15.3841C4.17541 15.7568 4.52611 16.0023 4.92294 16.0023H6.76868V25.0932C6.76868 25.5932 7.18397 26.0023 7.69155 26.0023H24.3032C24.8108 26.0023 25.2261 25.5932 25.2261 25.0932V16.0023H27.0718C27.4686 16.0023 27.8193 15.7477 27.9485 15.3841C28.0777 15.0114 27.9485 14.6023 27.6255 14.3659ZM23.3803 24.1841H8.61442V13.5023L15.9974 8.04773L23.3803 13.5023V24.1841Z"
    />
  </g>
</template>
